import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private collapsedSubject = new BehaviorSubject<boolean>(false);
  isCollapsed$ = this.collapsedSubject.asObservable();

  get isCollapsed(): boolean {
    return this.collapsedSubject.value;
  }

  toggle(): void {
    this.collapsedSubject.next(!this.collapsedSubject.value);
  }

  collapse(): void {
    this.collapsedSubject.next(true);
  }

  expand(): void {
    this.collapsedSubject.next(false);
  }
}
